import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getH2Token: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.H2,
    symbol: 'H2',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('H2'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/h2.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="H2"
        {...props}
      />
    ),
  };
};
